import { StyleableButton } from '@thanx/uikit/button'
import { Switch } from '@thanx/uikit/switch'
import { useStyletron } from '@thanx/uikit/theme'
import trash from 'assets/images/cms/trash.png'
import { buildTranslate } from 'locales'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  moveTabDown,
  moveTabUp,
  openDeleteModal,
} from 'slices/Cms/Content/AppNavigation/BottomNav'
import {
  selectCanDeleteTab,
  selectCanMoveTabDown,
  selectCanMoveTabUp,
} from 'slices/Cms/Content/AppNavigation/BottomNav/selectors'
import { NavigationTab } from 'slices/Cms/Content/AppNavigation/BottomNav/types'

const tBlocks = buildTranslate('cms.components.blocks')

type Props = {
  tab: NavigationTab
}

const Controls: React.FC<Props> = ({ tab }) => {
  const [css] = useStyletron()
  const dispatch = useDispatch()

  // Use selectors for business logic
  const canDelete = useSelector((state: any) =>
    selectCanDeleteTab(state, tab.id)
  )
  const canMoveUp = useSelector((state: any) =>
    selectCanMoveTabUp(state, tab.id)
  )
  const canMoveDown = useSelector((state: any) =>
    selectCanMoveTabDown(state, tab.id)
  )

  const handleOpenDeleteModal = () => {
    dispatch(openDeleteModal(tab.id))
  }

  const handleMoveUp = () => {
    dispatch(moveTabUp(tab.id))
  }

  const handleMoveDown = () => {
    dispatch(moveTabDown(tab.id))
  }

  return (
    <div className="d-flex flex-column align-items-center">
      <StyleableButton
        className="p-0"
        title={tBlocks('move_up', { index: tab.position, type: 'tab' })}
        disabled={!canMoveUp}
        onClick={handleMoveUp}
        data-testid={`BottomNav_TabDescription_Controls_${tab.id}_move_up`}
      >
        <i className="fa fa-caret-up fa-2x" />
      </StyleableButton>
      <p className="m-0">{tab.position}</p>
      <StyleableButton
        className="p-0"
        title={tBlocks('move_down', { index: tab.position, type: 'tab' })}
        disabled={!canMoveDown}
        onClick={handleMoveDown}
        data-testid={`BottomNav_TabDescription_Controls_${tab.id}_move_down`}
      >
        <i className="fa fa-caret-down fa-2x" />
      </StyleableButton>
      <Switch condition={canDelete}>
        <StyleableButton
          data-testid={`BottomNav_TabDescription_Controls_${tab.id}_delete`}
          className="mt-xs"
          onClick={handleOpenDeleteModal}
        >
          <img
            alt={tBlocks('delete', { type: 'navigation tab' })}
            className={css({ height: '16px' })}
            src={trash}
          />
        </StyleableButton>
      </Switch>
    </div>
  )
}

export default Controls
